import React, { useEffect, useRef } from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl';
import classNames from 'classnames';
import { Container, Row, Col, ScreenClassRender } from 'react-grid-system'

import {
  UniWorkflow,
  UniImg,
  UniButton,
  UniLocalize,
  EMessageType,
  UniOverlapGroup,
  UniOverlapButton,
} from '@unikey/unikey-commons/release/comm';

import {
  api,
  useAppDispatch,
  useAppSelector,
  addAlert,
  requestRefreshToken,
  attemptGetIdentityAccount,
  // updateSiteSwitcherAndActiveSiteAndVoluntaryNav,
  FooterContainer,
  PartnerCustomizations, IPartnerCustomizations,
  environment, partnerKey,
  ENavPages,
  navConfig,
  isLocationInviteAcceptUrl,
  attemptResendVerifyEmail,
  attemptGetIdentityAccountOptional
} from '../internal';
import partnerConfig from '@alias-current-partner-customizations';

interface IProps extends WrappedComponentProps, IPartnerCustomizations {
  history: any,
  darkModeActive: boolean,
}

interface IState {
  intervalRef?: any,
  intervalRunCount?: number,
}

const VerifyContainer: React.FC<IProps> = (props) => {

  const dispatch = useAppDispatch();
  const intervalRef = useRef(undefined);
  const intervalRunCountRef = useRef(0);

  const $emailVerified: boolean = useAppSelector(state => state.identity?.authIdentity?.acct?.emailVerified);
  const $alreadySent: boolean = useAppSelector(state => state.verifyEmailForm?.sent);
  const $resending: boolean = useAppSelector(state => state.verifyEmailForm?.loading);

  useEffect(() => {
    // here also for the refresh case.
    _checkAuthInfo();
    intervalRef.current = setInterval(() => {
      if (intervalRunCountRef.current! > 24) {
        // after running every 5 seconds for 24 times 
        // (2 minutes), stop the the background requests.
        clearInterval(intervalRef.current);
        return;
      }
      intervalRunCountRef.current = intervalRunCountRef.current + 1;
      _checkAuthInfo();

    }, 5000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    }

  }, []);

  useEffect(() => {
    if ($emailVerified) {
      // first request a refresh token so that the next calls are with a token for an email-verified user.
      requestRefreshToken(true).then(() => {
        // alert successfull verification
        dispatch(addAlert({
          id: Date.now(),
          titleKey: 'success',
          messageKeys: ['emailVerified'],
          type: EMessageType.success,
          duration: 4000 // 8000
        }));

        // // then trigger the site switcher and redirect to the landing page
        // // if the refresh logic didnt already redirect us
        // if (!isLocationInviteAcceptUrl()) {
        //   const cachedContinueTo = api.cacheImpl.get('continueTo');
        //   var desiredPage = navConfig.get(ENavPages.myAccount)!.linkTo([]);
        //   if (!!cachedContinueTo && cachedContinueTo !== 'null') {
        //     const continueHashRoute = decodeURIComponent(cachedContinueTo);
        //     desiredPage = `${continueHashRoute}`;
        //   }
          
          // dispatch(tokenRefreshDealerPortalBusiness());
        // } 
      })
    }
  }, [$emailVerified]);


  const _checkAuthInfo = () => {
    return dispatch(attemptGetIdentityAccountOptional());
  }

  const _resend = () => {
    dispatch(attemptResendVerifyEmail());
  }

  const imgClassName = classNames('partner-logo', {
    [partnerKey]: true
  });

  return (
    <ScreenClassRender render={(screenClass: string) => (
      <section className="access-container">
        <section className="verify-resend-container">
          <Container>
            <UniImg className={imgClassName} textKey="partner logo" src={props.darkModeActive ? partnerConfig.assets.logoOnDark : partnerConfig.assets.logoOnBackground} />
            <UniWorkflow
              titleKey="verifyEmail"
              titleIcon="email" >

              <p><UniLocalize translate="emailVerificiationRequired" /></p>
              <p><UniLocalize translate="mustVerifyEmailBeforeAccessing" /></p>
              <p><UniLocalize translate="requestNewVerificationEmail" /></p>

              {/* <br />
              <br /> */}


              <UniOverlapGroup>
                <UniOverlapButton
                  handleClick={() => _resend()}
                  textKey={!$alreadySent ? 'resendVerification' : 'emailSentShort'}
                  icon="send"
                  showLoader={$resending}
                  disabled={$alreadySent || $resending} 
                  />
              </UniOverlapGroup>

              {/* <UniButton
                fullWidth
                className="workflow-btn"
                handleClick={() => _resend()}
                textKey={!$alreadySent ? 'resendVerification' : 'emailSentShort'}
                icon="send"
                theme="invertedbox"
                tempDisableOnClick={true}
                disabled={$alreadySent || $resending}
                tooltipPosition="right" /> */}

              <div className="below-workflow">
                <a className="link-left" href="/#/login"><UniLocalize translate="backToHome" /></a>
              </div>

            </UniWorkflow>
          </Container>
        </section>

        <FooterContainer />

      </section>
    )} />
  )
}

export default PartnerCustomizations(injectIntl(VerifyContainer), {
  componentName: 'Verify' 
})
